import PropTypes from 'prop-types'
import React from 'react'
import classNames from 'classnames'

import Tag from '../Tag'
import Icon from '../Icon'

const SSRTag = ({
  ssr,
  classes,
  isNew,
  hasError,
  isAddedByTourOperator,
  onDestroy,
  onReset,
  toDelete,
  isDisabled,
}) => {
  return (
    <Tag
      className={classNames(classes.tag, {
        [classes.new]: isNew,
        [classes.hasError]: hasError,
        [classes.toDelete]: toDelete,
      })}
      data-element="error"
    >
      <input
        type="checkbox"
        id={`ssr-tag-ssr-${ssr.id}`}
        className={classes.checkbox}
        value={toDelete}
      />
      <span
        data-element={`ssr-tag-ssr-${ssr.id}`}
        data-has-error={hasError ? true : null}
      >
        {ssr.name ? ssr.name : ssr.id}
      </span>

      <label htmlFor={`ssr-tag-ssr-${ssr.id}`}>
        {!isDisabled && isAddedByTourOperator ? (
          toDelete ? (
            <Icon
              className={classes.iconClose}
              name="reset"
              onClick={onReset}
              data-element="reset-ssr-tag-icon"
            />
          ) : (
            <Icon
              className={classes.iconClose}
              name="close"
              onClick={() => onDestroy(ssr.id)}
              data-element="delete-ssr-tag-icon"
            />
          )
        ) : (
          false
        )}
      </label>
    </Tag>
  )
}

SSRTag.propTypes = {
  classes: PropTypes.shape({
    tag: PropTypes.string,
    new: PropTypes.string,
    iconClose: PropTypes.string,
    toDelete: PropTypes.string,
  }),
  ssr: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
  }).isRequired,
  isNew: PropTypes.bool,
  hasError: PropTypes.bool,
  isAddedByTourOperator: PropTypes.bool,
  onDestroy: PropTypes.func,
  toDelete: PropTypes.bool,
  onReset: PropTypes.func,
  isDisabled: PropTypes.bool,
}

SSRTag.defaulProps = {
  isNew: false,
  isDisabled: false,
}

export default SSRTag
